<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48"><title>{{ title }}</title>
    <g :fill="fill">
      <circle cx="24" cy="24" r="7"></circle>
      <path
        d="M15,24c0-4.11169,2.7746-7.58002,6.54718-8.65155L14.89697,3.88574 c-0.2666-0.45898-0.84473-0.62891-1.31787-0.38965C9.59863,5.51953,6.31396,8.63281,4.08105,12.5 C1.8501,16.36426,0.7959,20.76367,1.03271,25.2207c0.02832,0.53027,0.46533,0.94629,0.99609,0.94727l13.2547,0.03296 C15.1051,25.49512,15,24.7605,15,24z"></path>
      <path
        d="M30.2655,30.44781C28.64362,32.02423,26.43494,33,24,33c-2.43457,0-4.64301-0.97559-6.26483-2.55157 l-6.59845,11.49493c-0.26416,0.45996-0.12305,1.04688,0.32178,1.33594C15.2002,45.71387,19.53662,47,24,47 c4.46533,0,8.80371-1.28711,12.5459-3.72363c0.44482-0.28906,0.58594-0.87598,0.32178-1.33594L30.2655,30.44781z"></path>
      <path
        d="M43.91895,12.5c-2.23291-3.86719-5.51758-6.98047-9.49805-9.00391 c-0.47314-0.23926-1.05176-0.06934-1.31787,0.38965l-6.65021,11.46271C30.2254,16.41998,33,19.88831,33,24 c0,0.7605-0.1051,1.49512-0.28351,2.20093l13.2547-0.03296c0.53076-0.00098,0.96777-0.41699,0.99609-0.94727 C47.2041,20.76367,46.1499,16.36426,43.91895,12.5z"></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Radiation",
  props: {
    title: {
      default: 'Radiation',
      type: String,
    },
    fill: {
      default: 'currentColor',
      type: String,
    },
    size: {
      type: Number,
      default: 28,
    },
  },
}
</script>

<style scoped lang="scss">
.spinning {
  animation: spin 3s linear infinite;
  g {
    animation: changeColor 1.5s alternate infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(359deg);
  }
}

@keyframes changeColor {
  0% {
    fill: currentColor;
  }

  100% {
    fill: var(--green);
  }
}
</style>
